// Deterministic "colored initials" avatar background, so a user's avatar always renders
// the same color across sessions/reloads instead of the flat single-tone circle MUI's
// Avatar falls back to when there's no image.
//
// Palette and hash are deliberately identical to getAvatarColor() in
// components/reviewsLeaderboard/LeaderboardTable.jsx (and PodiumSection.jsx) — the same
// person must get the same avatar color on every screen that renders one, so this can't
// invent its own colors. Kept here as the shared copy rather than a fourth duplicate.
const AVATAR_COLORS = [
  "#FF5200", "#6366F1", "#10B981", "#F59E0B",
  "#EC4899", "#8B5CF6", "#14B8A6", "#F97316",
];

export function stringToColor(value) {
  if (!value) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function initialsOf(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || "";
  const second = parts.length > 1 ? parts[parts.length - 1]?.[0] || "" : "";
  return (first + second).toUpperCase();
}

// `image` on User is messy in practice: 141 users hold a real Google photo URL, 32 hold
// the schema default `1`, and 4 hold an empty string. Passing "1" to <Avatar src> fires a
// pointless request that 404s before falling back, so only a real URL is handed over —
// everything else goes straight to initials.
export function avatarSrc(image) {
  return typeof image === "string" && image.startsWith("http") ? image : undefined;
}
